<app-header></app-header>

<!--section-->
<section class="sptb">
	<div class="container app-content">
		<div class="text-justify">
			<div class="page-header">

				<h4 class="page-title pt-3 pb-3">About Okshan</h4>
				<!-- <div class="update_status"><span>Last updated on  12 / 2/2019</span></div>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="#">CMS</a></li>
							<li class="breadcrumb-item active" aria-current="page">Privacy Policy</li>
						</ol> -->
			</div>
			<div class="card card-body" style="margin-top:25px;">
				<!-- <h4 class="leading-Automatic">Majority have suffered alteration in some form, by injected humor</h4> -->
				<p class="leading-Automatic">Okshan.com, a brand of Sanch Motors Private Limited, Company incorporated
					under Companies Act, 2013, with vision to provide transparent online auction platform to the car
					dealers and used car traders across India with seamless experience in buying and selling of used
					cars.</p>
				<p class="leading-Automatic">We are a neutral facilitator between the seller and the buyer and don't put
					any pressure on either party. We have made a marketplace/platform wherein people can sell and buy
					used cars. This means you don’t just pay fair prices, you pay the fairest price.</p>
				<p class="leading-Automatic mb-0">By acting honestly, respectfully and ethically, we establish trusting
					relationships with you.
					Whether you are a buyer, seller, partner, supplier or one of our employees. Because we believe
					you matter. Your opinion matters. As is your satisfaction with our services.</p> <br>
				<p class="leading-Automatic">Today, diversification and risk management are essential factors in the
					professional trading of
					used cars. Our diversified portfolio enables high throughput and higher contribution margins.
					With OKSHAN as a reliable sourcing channel, partner dealers can actively manage their vehicle
					inventory, ensuring long-term competitiveness and success in the used car business.</p><br>
				<p class="leading-Automatic">For the digital B2B acquisition, a cross-brand huge inventory will be
					available to all dealers at
					market-based purchasing conditions, which is supplemented daily new additions. Dealers
					across India have the opportunity to purchase tested and fully documented used cars directly
					from okshan.com with just a few mouse clicks - without hidden fees or minimum purchases.
					With its professional and friendly support team, okshan.com also supports its partner dealers
					with purchase, after-sales, logistics, and transport services.</p><br>
			</div>
		</div>
	</div>
</section>
<!--/section-->

<section class="sptbm">
	<div class="container app-content">
		<div class="text-justify">
			<div class="page-header">

				<h4 class="page-title pt-3 pb-3">Our Mission</h4>
				<!-- <div class="update_status"><span>Last updated on  12 / 2/2019</span></div>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="#">CMS</a></li>
							<li class="breadcrumb-item active" aria-current="page">Privacy Policy</li>
						</ol> -->
			</div>
			<div class="card card-body" style="margin-top:25px;margin-bottom:20px;">
				<h4 class="leading-Automatic">To become the top site in India for the auction of remarketed vehicles.
				</h4>
				<p class="leading-Automatic"><i class="fa fa-circle" aria-hidden="true"></i>With a unique combination of
					expertise in remarketing, the automotive sector and
					customer service.</p>
				<p class="leading-Automatic"><i class="fa fa-circle" aria-hidden="true"></i>With industrialized
					operations that ensure service, quality and a transparent, reliable
					cost structure.</p>
				<p class="leading-Automatic mb-0"><i class="fa fa-circle" aria-hidden="true"></i>And with determination
					to not just meet your expectations, but to exceed them every
					time you place a bid, every time you contact us with questions. Every time you visit
					okshan.com</p> <br>
			</div>

		</div>
	</div>
</section>

<!--/Statistics-->

<!--section-->
<section class="sptb bg-white">
	<div class="container">
		<div class="section-title center-block text-center">
			<h2 class="mb-4"> Our Team</h2>
			<!-- <p>Mauris ut cursus nunc. Morbi eleifend, ligula at consectetur vehicula</p> -->
		</div>
		<div class="row">
			<div class="col-md-12">
				<h4 style="font-size: 25px;text-align:center;">RANJEEV DAHUJA</h4>
				<div class="col-md-12 how-img" style="text-align:center;">
					<img src="assets/images/Ranjeev.jpg" style="height:215px;">
				</div>
			</div>
			<div class="col-md-12">
				<!-- <h4 class="subheading">GetLance makes it easy to connect with clients and begin doing great work.</h4> -->
				<h5> <span style="text-decoration: underline; font-weight: bold;">EXPERIENCE: </span> 27 YEARS </h5>
				<p class="leading-Automatic"> <span style="text-decoration: underline; font-weight: bold;">
						Expertise:</span>
					Ranjeev Dahuja, 55 years old, a Qualified Chartered Accountant, after a
					small span of practice ventured
					into finance business, started career in Syndication of Loans. Later on in 2001, started a used car
					brand
					in the name &amp; style of “Berkeley Automall” and parallely ventured in Auto Dealership Business.
					During
					his long business journey, one thing that he had earned was a huge and loyal customer base because
					of
					his business ethics that was transparent and customer oriented.</p>

				<p class="leading-Automatic">During his career, he has worked with lot of Car Manufacturers, Banks,
					NBFC’s &amp; Insurance Companies
					and enjoys an enormous goodwill wherever he has worked as an Associate.</p>

			</div>
			<p class="leading-Automatic" style="margin-left: 12px;">Today he holds 27 years of experience in Automobile
				Industry and Finance Market. He has excellent
				hold on financial planning &amp; strategies and holds good grip on Sales Management Planning, believes
				in
				Teamwork and Collaboration and is open for communications.</p>

			<p class="leading-Automatic" style="margin-left: 12px;">He also counts manpower as one of the biggest
				strengths and believes that “Good manpower can help
				you build a good customer base”. He also believes in investing in manpower as a result of which he
				doesn't face any attrition issues. Apart from this, he believes in delegating work, empowering people in
				the team and giving authority that is another factor of business growth and motivating employees to
				achieve success.</p>
			<p style="margin-left: 12px;"><strong> Ranjeev Dahuja's Success Mantra: </strong></p><br>
			<p>
				- Check Financial Viability of Project<br>
				- Goodwill and market you make for yourself<br>
				- Being Transparent to customers<br>
				- Customer first approach<br>
				- Invest in good manpower<br>
				- Keeping eye on inventory and Stock management<br>
				- Stop price war among other dealers</p>

		</div>

		<div class="row">
			<div class="col-md-12">
				<h4 style="font-size: 25px;text-align:center;">ANJANI MISHRA</h4>
				<!-- <h4 class="subheading">EXPERIENCE: 18 YEARS</h4> -->

				<div class="col-md-12 how-img" style="text-align:center;">
					<img src="assets/images/Anjani.jpg" style="height:215px;">
				</div>
				<!-- <h4 class="subheading">GetLance makes it easy to connect with clients and begin doing great work.</h4> -->
				<h6> <span style="text-decoration: underline; font-weight: bold;">EXPERIENCE: </span> 18 YEARS </h6>
				<p class="leading-Automatic"> <span style="text-decoration: underline; font-weight: bold;">
						Expertise:</span> Sales-oriented professional with expertise in B2B Sales, setting up
					distributor led sales model, client relationship management, customer satisfaction and retention,
					people management and new market expansion in India as well as South East Asian Countries. Possess
					astute business knowledge, and has experience in contributing to strategic planning while delivering
					improvements in processes, productivity and costs.</p>
				<p class="leading-Automatic">Has worked in Billion Dollar set up as well as start up. Also, he has
					managed team size of 2000+ manpower working with Mphasis (An HP Company) while managing Punjab
					National Bank (PNB) customer care Pan India. Worked for almost 5 years with Golf Technology Startup
					and have managed Middle East as well as South East Asia for Sales and Business Development.</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<h4 style="font-size: 25px;text-align:center;">RAJINDER AGGARWAL</h4>
				<div class="col-md-12 how-img" style="text-align:center;">
					<img src="assets/images/Rajinder_Sir_Pic.jpg" style="height:215px; width:193px;">
				</div>
				<!-- <h4 class="subheading">GetLance makes it easy to connect with clients and begin doing great work.</h4> -->
				<h5> <span style="text-decoration: underline; font-weight: bold;">EXPERIENCE: </span> 23 YEARS </h5>
				<p class="leading-Automatic"> <span style="text-decoration: underline; font-weight: bold;">
						Expertise:</span> Rajinder Aggarwal is a qualified Chartered Accountant with overall
					experience of 23 years and is in
					practice for the last 8 years. He has wide ranging expertise in Automobile and Finance Industry,
					Leading
					the team for Financial Services, Taxation, Accounting Systems and Audit matters. Well versed in
					fields of
					tax laws, accounting and auditing standards, management consultancy and risk management.</p>

				<p class="leading-Automatic">Has wide range of experience in subjects of Corporate Soliciting,
					Incorporation, Legal Examination of
					Company Policies &amp; Resolutions, Drafting &amp; Execution of Agreements and Contracts and Due
					Diligence
					on Company, Finance, Administrative Approvals, Negotiable Instruments. Has experience in providing
					consultancy in various corporate and taxation litigations.</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<h4 style="font-size: 25px;text-align:center;">CA. Dinesh Kumar Kohli </h4>
				<div class="col-md-12 how-img" style="text-align:center;">
					<img src="assets/images/Dinesh_Sir_Pic.jpeg" style="height:215px; width:193px;">
				</div>
				<h5> <span style="text-decoration: underline; font-weight: bold;">EXPERIENCE: </span> 20 YEARS </h5>
				<p class="leading-Automatic"> <span style="text-decoration: underline; font-weight: bold;">
						Expertise:</span> Mr. Dinesh Kumar Kohli is a fellow member of Institute of Chartered
					Accountants of India. He qualified as Chartered Accountant, having 20 years of post-qualification
					experience in the field of Accounting, Auditing, Finance, Project Financing & Taxation. His ability
					to understand the business environment coupled with his sound financial and accounting background
					has enabled him to specialize inco-ordinating all aspects of business operations & various projects
					from inception through completion. He has extensively worked on several audit assignments across
					diverse verticals and has served clients ranging manufacturing units, Traders, Public Sector
					Undertakings, Services Sectors, banks etc., handling end-to-end engagement. Apart from above, he has
					vast experience of project financing and appraisal assignments for various banks and financial
					institutions. He is associated with Berkeley Group for the last 15 years on various fronts. </p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<h4 style="font-size: 25px;text-align:center;">RUPESH TIWARI</h4>
				<div class="col-md-12 how-img" style="text-align:center;">
					<img src="assets/images/rupesh_sir_pic.jpg" style="height:215px; width:193px;">
				</div>
				<!-- <h4 class="subheading">GetLance makes it easy to connect with clients and begin doing great work.</h4> -->
				<h5> <span style="text-decoration: underline; font-weight: bold;">EXPERIENCE: </span> 18 YEARS </h5>
				<p class="leading-Automatic"> <span style="text-decoration: underline; font-weight: bold;">
						Expertise:</span> Experience in identifying, qualifying, building consensus for, enabling
					technologies and enterprise solutions that facilitate business processes, and digital transformation
					objectives. Powerful blend of technology vision and business acumen results in consistent
					development of powerful business strategies supported by cost-effective, high-performance solutions
					and applications. Broad expertise in Automobile, Telecom solution, Banking solution, Digital
					Transformation and Architecture design, Project life cycle management and stakeholder/vendor
					relationship management. Worked at WPP Scangroup Africa, provided technology leadership for Ogilvy
					One Africa and Squad Digital for Kenya, Tanzania, Zambia, Nigeria, and Ghana. I had worked closely
					with Safaricom, Airtel, Vodafone and Tigo team to help them with new and existing product strategies
					and digital enablement.</p>
			</div>
		</div>
	</div>
</section>
<!--/section-->
<app-footer></app-footer>